var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0.961609C80.5479 0.961609 103.717 24.1309 103.717 52.6788C103.717 81.2267 80.5479 104.396 52 104.396C23.4521 104.396 0.282837 81.2267 0.282837 52.6788C0.282837 24.1309 23.4521 0.961609 52 0.961609ZM21.0887 70.3454C28.6807 81.6714 40.0792 88.8808 52.8275 88.8808C65.5706 88.8808 76.9742 81.6766 84.5611 70.3454C75.9541 62.3013 64.6084 57.834 52.8275 57.8505C41.0448 57.8327 29.697 62.3 21.0887 70.3454ZM52 47.5071C56.1149 47.5071 60.0612 45.8724 62.9709 42.9628C65.8805 40.0531 67.5152 36.1068 67.5152 31.9919C67.5152 27.877 65.8805 23.9307 62.9709 21.021C60.0612 18.1114 56.1149 16.4768 52 16.4768C47.8851 16.4768 43.9388 18.1114 41.0291 21.021C38.1195 23.9307 36.4849 27.877 36.4849 31.9919C36.4849 36.1068 38.1195 40.0531 41.0291 42.9628C43.9388 45.8724 47.8851 47.5071 52 47.5071Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.9723217d53f5621a54bf849a05c54d14.svg";
export { ForwardRef as ReactComponent };